import { useEffect, useState } from "react";
import { useVersionChecker } from "./useVersionChecker";
import { TuseBanner } from "../types/index";

/**
 * Custom hook to control banner UI logic for version checking
 * Uses useVersionChecker hook to fetch and compare versions
 * @returns {Object} Banner control methods and state
 * @returns {boolean} isVisible - Whether banner should be displayed
 * @returns {Function} handleReload - Reloads the page
 * @returns {Function} handleClose - Closes the banner
 * @returns {string} version - Current version number
 */

export const useBanner = (): TuseBanner => {
    const { version, currentversion, isLoading, isFetching } = useVersionChecker()
    const [isVisible, setIsVisible] = useState(false);
    const handleReload = () => {
        window.location.reload();
    };
    const handleClose = () => {
        setIsVisible(false);
    };
    useEffect(() => {
        if (currentversion.localeCompare(version, undefined, { numeric: true, sensitivity: 'base' }) >= 0 || isLoading || isFetching) {
            setIsVisible(false);
        } else {
            setIsVisible(true);
        }
        return () => {

        }
    }, [version, isLoading, isFetching, currentversion])
    return {
        isVisible,
        handleReload,
        handleClose,
        version
    }
}